module.exports = __webpack_public_path__ + "8844445fe48afd8218211922fc322e71.svg";